<template>
	<div>
		<CurrencyPopup :showCurrencyPopup="showCurrencySelector" :currencies="currencies" :currencyModule="currencyModule" @changeCurrency="currencyChanged" @hide="hidePopup" />
		<div class="total__line total__line--taxes">
			<div class="label">
			</div>
			<div class="value value--currency">
				<span id="curr_select" v-if="currencies && showCurrencySelector" ref="currencyToggle" @click.stop.prevent="hidePopup"  @keydown.enter.prevent="hidePopupEnter" v-html="language.changeCurrency"></span>
				<span id="curr_select" v-if="currencies && !showCurrencySelector" ref="currencyToggle" @click.stop.prevent="showPopup" @keydown.enter.prevent="showPopupEnter" v-html="language.changeCurrency"></span>
			</div>
		</div>
	</div>
</template>

<script>
import CurrencyPopup from './components/widget/CurrencyPopup'
export default {
	name: 'Currencypopupsub',
	components: {
		CurrencyPopup
	},

	data: function(){
		return {
			currencies: null,
			currencyModule: null,
			showCurrencySelector: false
		}
	},

	mounted() {
		// there is an event implemented for wmx scripts to be loaded
		const that = this
		const currency_symbols_sub = {"EUR":{"symbol":"\u20ac","name":"\u20ac"},"USD":{"symbol":"$","name":"$"},"GBP":{"symbol":"\u00a3","name":"\u00a3"}};

		document.body.addEventListener('wmx:loaded', function(){
			that.currencies = Object.assign({}, currency_symbols_sub)
			for (let i = 0; i < that.currencies.length; i++) {
				that.currencies[i].active = false
			}
			that.currencyModule = window.citizenm.currencyModule
		})
	},

	computed: {
		language() {
			return this.$store.state.language
		}
	},
	methods: {
		showPopup(e){
			this.showCurrencySelector = true
			console.log(e)
			console.log('showPopup')
			console.log(this.showCurrencySelector)
		},
		hidePopup(){
			this.showCurrencySelector = false
		},
		showPopupEnter(e){
			this.showCurrencySelector = true
			console.log(e)
		},
		hidePopupEnter(e){
			console.log(e)
			this.showCurrencySelector = false
		},
		currencyChanged() {
			this.$emit('changeCurrency')
			this.showCurrencySelector = false
		}
	},
	watch: {
		// currencyPopupOpened() {
		// 	this.showCurrencySelector = this.currencyPopupOpened
		// }
	}
}
</script>